import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./user-avatar.module.css";
import UserInitialsAvatar from "@atlas/uicorn/lib/Display/UserInitialsAvatar";
import User from "../models/user";
import cn from "classnames";

const UserAvatar = function UserAvatar({ user, size = 22 }: TUserAvatarProps) {
  const { id, firstName, lastName, profileUrl } = user;

  const inlineStyles = useMemo<React.CSSProperties | undefined>(() => {
    if (typeof size !== "number") return;
    const sizeInPx = `${size}px`;

    return {
      width: sizeInPx,
      height: sizeInPx,
      lineHeight: sizeInPx,
    };
  }, [size]);

  const [loaded, setLoaded] = useState(false);
  const handleImageLoad = useCallback(() => setLoaded(true), []);
  useEffect(() => setLoaded(false), [profileUrl]);

  return (
    <span className={styles.userAvatarWrapper} style={inlineStyles}>
      <img
        className={cn(styles.image, { [styles.loaded]: loaded })}
        loading="lazy"
        src={profileUrl}
        onLoad={handleImageLoad}
      />
      {!loaded && (
        <UserInitialsAvatar
          firstName={firstName}
          lastName={lastName}
          size={size}
          id={id}
        />
      )}
    </span>
  );
};

export default UserAvatar;

type TUserAvatarProps = Omit<React.HTMLAttributes<HTMLElement>, "children"> & {
  user: User;
  size?: number;
};
